import React from "react";
import {
  AiRecipeCard,
  BlankRecipeCard,
  Grid,
  TemplateRecipeCard,
} from "./RecipePickerStep.styles";
import {
  TEMPLATE_RECIPES,
  type RecipePickerStepProps,
} from "./RecipePickerStep.types";

/**
 * Recipe picker step body — Figma 5326:88009.
 *
 * Extracted from `CreateDataStoryRecipeModal` so it satisfies the same
 * `{ values, onChange }` contract as every other registry step. The modal
 * chrome it used to carry now comes from `DataStoryModalShell`.
 */
export const RecipePickerStep: React.FC<RecipePickerStepProps> = ({
  values,
  onChange,
  templates = TEMPLATE_RECIPES,
}) => {
  const { selectedRecipeId } = values;
  const select = (id: typeof selectedRecipeId) =>
    onChange({ selectedRecipeId: id });

  return (
    <Grid $columns={templates.length > 0 ? 3 : 2}>
      <BlankRecipeCard
        $selected={selectedRecipeId === "blank-canvas"}
        selected={selectedRecipeId === "blank-canvas"}
        onSelect={() => select("blank-canvas")}
      />
      <AiRecipeCard
        $selected={selectedRecipeId === "ai"}
        selected={selectedRecipeId === "ai"}
        onSelect={() => select("ai")}
      />
      {templates.map(({ id, title, kind, pickerPreview, important }) => {
        return (
          <TemplateRecipeCard
            key={id}
            $selected={selectedRecipeId === id}
            selected={selectedRecipeId === id}
            title={title}
            description=""
            kind={kind}
            presentation="picker"
            pickerPreview={pickerPreview}
            important={important}
            storyCount={0}
            owner={{ name: "MagicBI" }}
            onClick={() => select(id)}
          />
        );
      })}
    </Grid>
  );
};

export default RecipePickerStep;
